document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((element) => observer.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }

  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('menu-open', menu.open);
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });
    menu.querySelectorAll('[data-menu-close]').forEach((button) => {
      button.addEventListener('click', () => menu.removeAttribute('open'));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    const buttonLabel = addButton?.querySelector('[data-add-label]');
    const price = document.querySelector('[data-main-product-price]');
    const comparePrice = document.querySelector('[data-compare-price]');
    const gallery = document.querySelector('[data-product-gallery]');
    const lightbox = document.querySelector('[data-product-lightbox]');
    const mediaItems = gallery ? [...gallery.querySelectorAll('[data-gallery-media]')] : [];
    let activeMedia = mediaItems.find((item) => !item.hidden) || mediaItems[0];
    let transitionTimer;
    const syncLightbox = () => {
      if (!lightbox?.open || !activeMedia) return;
      const image = lightbox.querySelector('img');
      const source = activeMedia.querySelector('[data-gallery-zoom]')?.href ||
        gallery.querySelector(`[data-gallery-thumb][data-media-id="${activeMedia.dataset.mediaId}"] img`)?.src;
      if (source && image.src !== source) {
        image.classList.remove('is-visible');
        image.src = source;
        image.alt = activeMedia.querySelector('img')?.alt || '';
        const reveal = () => { if (image.src === source) image.classList.add('is-visible'); };
        if (image.decode) image.decode().catch(() => {}).then(reveal);
        else reveal();
      }
      lightbox.querySelector('[data-lightbox-counter]').textContent =
        `${String(mediaItems.indexOf(activeMedia) + 1).padStart(2, '0')} / ${String(mediaItems.length).padStart(2, '0')}`;
    };
    const showMedia = (id) => {
      if (!id || !gallery) return;
      const match = mediaItems.find((item) => item.dataset.mediaId === id);
      if (!match) return;
      window.clearTimeout(transitionTimer);
      mediaItems.forEach((item) => {
        item.classList.remove('is-entering', 'is-exiting');
        if (item !== activeMedia) item.hidden = true;
      });
      if (match !== activeMedia) {
        const previous = activeMedia;
        match.hidden = false;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          previous?.classList.add('is-exiting');
          match.classList.add('is-entering');
          transitionTimer = window.setTimeout(() => {
            if (previous) { previous.hidden = true; previous.classList.remove('is-exiting'); }
            match.classList.remove('is-entering');
          }, 350);
        } else if (previous) previous.hidden = true;
        activeMedia = match;
      }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const active = thumb.dataset.mediaId === id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      const index = mediaItems.indexOf(match);
      const current = gallery.querySelector('[data-gallery-current]');
      const progress = gallery.querySelector('[data-gallery-progress]');
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (progress) progress.style.width = `${((index + 1) / mediaItems.length) * 100}%`;
      syncLightbox();
    };
    const stepMedia = (direction) => {
      if (mediaItems.length < 2) return;
      const next = (mediaItems.indexOf(activeMedia) + direction + mediaItems.length) % mediaItems.length;
      showMedia(mediaItems[next].dataset.mediaId);
    };
    gallery?.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) showMedia(thumb.dataset.mediaId);
      const control = event.target.closest('[data-gallery-direction]');
      if (control) stepMedia(Number(control.dataset.galleryDirection));
      const zoom = event.target.closest('[data-gallery-zoom]');
      if (zoom && lightbox?.showModal) {
        event.preventDefault();
        lightbox.showModal();
        syncLightbox();
      }
    });
    const stage = gallery?.querySelector('.tm-product-editorial__stage');
    let touchStart = null;
    stage?.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' && !event.target.closest('button, a'))
        touchStart = { x: event.clientX, y: event.clientY };
    });
    stage?.addEventListener('pointerup', (event) => {
      if (!touchStart) return;
      const dx = event.clientX - touchStart.x;
      const dy = event.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) stepMedia(dx < 0 ? 1 : -1);
    });
    stage?.addEventListener('pointercancel', () => { touchStart = null; });
    lightbox?.addEventListener('click', (event) => {
      if (event.target.closest('[data-lightbox-close]')) lightbox.close();
      const control = event.target.closest('[data-lightbox-direction]');
      if (control) stepMedia(Number(control.dataset.lightboxDirection));
    });
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); stepMedia(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); stepMedia(1); }
    });
    form.querySelectorAll('[data-quantity-step]').forEach((stepper) => {
      stepper.addEventListener('click', () => {
        const input = form.querySelector('[name="quantity"]');
        if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(stepper.dataset.quantityStep));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (!variantSelect || !addButton) return;

    variantSelect.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      const available = selected.dataset.available === 'true';
      addButton.disabled = !available;
      if (buttonLabel) buttonLabel.textContent = available ? addButton.dataset.addAvailableLabel : addButton.dataset.addSoldLabel;
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = selected.dataset.comparePrice || '';
        comparePrice.hidden = !selected.dataset.comparePrice;
      }
      showMedia(selected.dataset.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url.toString());
    });
    if (variantSelect.tagName === 'SELECT') showMedia(variantSelect.options[variantSelect.selectedIndex]?.dataset.mediaId);
  });
});
